// Shown wherever the app offers to copy a one-time product's storefront link while the
// product is not on sale.
//
// The link points at a storefront page that only exists once the product is ready for
// sale, so every place offering it gates on that same flag and says the same thing. It is
// deliberately not about publishing pages: a product's sales page does not have to be
// published for its link to work.
export const PRODUCT_SHARE_GATE_MESSAGE = 'Mark this product as ready for sale before sharing the link'

// Every share link starts with my.trybe.fit/{link handle}, so none can be shared until the
// coach sets the handle.
export const NO_LINK_HANDLE_SHARE_MESSAGE = 'Set your link handle in Sell settings before sharing the link'

// The membership storefront doesn't load until its checkout page is published
export const MEMBERSHIP_SHARE_GATE_MESSAGE = 'Publish your checkout page before sharing your membership link'
